import { render, staticRenderFns } from "./OneShop.vue?vue&type=template&id=b2361df4&scoped=true&"
import script from "./OneShop.vue?vue&type=script&lang=js&"
export * from "./OneShop.vue?vue&type=script&lang=js&"
import style0 from "./OneShop.vue?vue&type=style&index=0&id=b2361df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2361df4",
  null
  
)

export default component.exports